import { type, type Type } from 'arktype';
import { dayKeySchema } from './day-key.model';
import { narrowError } from './schema-narrow';

function holidayError(holiday: { date: string; weekend: boolean }): string | null {
  const weekday = new Date(`${holiday.date}T00:00:00Z`).getUTCDay();
  return holiday.weekend === (weekday === 0 || weekday === 6) ? null : 'a weekend flag matching the calendar weekday';
}

export interface Holiday {
  date: string;
  name: string;
  weekend: boolean;
  types: string[];
}

export const holidaySchema: Type<Holiday> = type({
  date: dayKeySchema,
  name: 'string > 0',
  weekend: 'boolean',
  types: type('string > 0').array(),
})
  .narrow(narrowError(holidayError))
  .onUndeclaredKey('reject');
